import { LoaderFunctionArgs } from "react-router-dom";
import { CourseDetail } from "@/routes/course/types/courseDetail.ts";
import { apiEndpoints } from "@/services/api/api.ts";
import { authService } from "@/services/auth/authService.ts";

export interface CourseLoaderData {
  course: CourseDetail;
  courseProgress: number | null;
  isAuthenticated: boolean;
}

export async function courseLoader({
  params,
}: LoaderFunctionArgs): Promise<CourseLoaderData> {
  if (!params.courseId) {
    throw new Error("Course ID is required");
  }

  const courseId = params.courseId;
  const isAuthenticated = !!authService.getAccessToken();

  const [courseResponse, sidebarResponse] = await Promise.allSettled([
    isAuthenticated
      ? apiEndpoints.courseDetail(courseId)
      : apiEndpoints.getPublicCourseDetail(courseId),
    isAuthenticated
      ? apiEndpoints.getCourseSidebarData(courseId)
      : apiEndpoints.getPublicCourseSidebarData(courseId),
  ]);

  if (courseResponse.status === "rejected" || !courseResponse.value.success) {
    throw new Error("Kurs yüklenemedi");
  }

  const course = courseResponse.value.data as CourseDetail;

  let courseProgress: number | null = null;
  if (
    sidebarResponse.status === "fulfilled" &&
    sidebarResponse.value.success
  ) {
    courseProgress = sidebarResponse.value.data.courseProgress;
  }

  return { course, courseProgress, isAuthenticated };
}
